/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type GetConversationCareplanChatConversationIdCareplanGetParams = {
  /**
   * If provided, the clinic conversation is resolved through this ClinicRequest, which pins a single visit. This is the preferred way to resolve the clinic conversation and callers should migrate to it: the fallback path via the Nori conversation's curai_conversation_id is deprecated because that pointer only tracks the most recent visit and misses older ones when a Nori conversation has multiple visits.
   */
  clinic_request_id?: string | null;
};
